import { format, subDays } from "date-fns"
import { useMemo } from "react"
import { NavLink } from "react-router-dom"
import { ReportFilters } from "../../component/filters/report-filters.tsx"
import { Column, ReactTailwindTable, useTable } from "../../component/react-tailwind-table"
import { useFilters } from "../../component/use-filter"
import { useGetAllPerformersQuery } from "./service"
import { useSelection } from "../../app/department-context.tsx"
import { CellContext } from "@tanstack/react-table"

export const TopReport = () => {
  const { selectedDepartment } = useSelection()
  const { filters, updateFilters } = useFilters({
    params: {
      startDate: "string",
      endDate: "string",
      departmentId: "number",
      callTypeId: "number",
      intentDirection: "string",
    },
    defaults: {
      departmentId: selectedDepartment?.id,
      startDate: format(subDays(new Date(), 30), "yyyy-MM-dd"),
      endDate: format(new Date(), "yyyy-MM-dd"),
      intentDirection: "",
    },
  })
  const operatorDataTable = useTable({ defaultPageSize: 10 })

  const { data: performersData } = useGetAllPerformersQuery({ ...filters }) as {
    data?: { crmColumns?: { key: string; title: string }[] }
  }

  const operatorDataColumns: Column<any>[] = useMemo(
    () => [
      {
        header: "Оператор",
        accessorKey: "operator_name",
        cell: ({ row }) => (
          <NavLink
            className={"underline"}
            to={`/app/operator-report?operatorId=${row.original.operator_id}&startDate=${filters.startDate}&endDate=${filters.endDate}`}
          >
            {row.original.operator_name}
          </NavLink>
        ),
      },
      { header: "Средняя оценка", accessorKey: "avg_score" },
      {
        header: "Результативность",
        accessorKey: "result_performance",
        cell: ({ row }) => <span>{row.original.result_performance}%</span>,
      },
      ...(performersData?.crmColumns ?? []).map(({ key, title }: { key: string; title: string }) => ({
        header: title,
        accessorKey: key,
        cell: ({ row }: CellContext<Record<string, unknown>, unknown>) => (
          <span>{(row.original[key] as string | number | null) ?? "-"}</span>
        ),
      })),
      { header: "Кол-во звонков", accessorKey: "call_count" },
      { header: "Среднее время звонка", accessorKey: "avg_duration" },
    ],
    [filters.endDate, filters.startDate, performersData?.crmColumns],
  )

  return (
    <div>
      <div className="max-w-7xl mx-auto bg-white dark:bg-base-200 p-6 sm:p-8 rounded-lg shadow-sm">
        <h1 className="text-xl sm:text-2xl font-bold text-center text-teal-800 mb-2">Сводный отчет "Лучшие/Худшие"</h1>

        <ReportFilters filters={filters} updateFilters={updateFilters} showCallTypeFilter showIntentDirectionFilter />

        <div className="mb-8">
          <ReactTailwindTable
            columns={operatorDataColumns}
            query={useGetAllPerformersQuery}
            queryParams={{ ...filters }}
            {...operatorDataTable}
            visibilityOptions={{
              disablePagination: true,
            }}
            tableId="operatorDataTable"
          />
        </div>
      </div>
    </div>
  )
}
